<a
  class="circulo"
  (click)="openWhatsapp()"
  href="https://web.whatsapp.com/send?phone=+573153555551"
  class="btn-wsp"
  (click)="openWhatsapp()"
  href="https://wa.me/573153555551?text=Hola,%20necesito%20soporte%20t%C3%A9cnico.%20Tengo%20una%20consulta%20relacionada%20con%20la%20plataforma%20SIGESS%20y%20agradecer%C3%ADa%20su%20ayuda%20para%20resolverla."
  target="_blank"
  rel="noopener noreferrer"
>
  <img src="../../../../assets/svg/whatsapp.svg" alt="WhatsApp" />
  <div class="ocultar">Asesoría inmediata por <strong>WhatsApp</strong></div>
</a>